export default __webpack_public_path__ + "static/media/planet-sm.aa034a8e.svg";